import {useQuery} from '@tanstack/react-query';
import {getCurrentUser} from '../handlers/users';

export const useGetCurrentUser = (autoRefetch = false) => {
    return useQuery(['me'], () => getCurrentUser(), {
        enabled: autoRefetch,
        retry: false,
    });
};
